import magnifier from './assets/images/magnifier.svg';
import play from './assets/images/play.svg';
import smiley from './assets/images/smiley.svg';

import agric from './assets/images/agric.svg';
import biology from './assets/images/biology.png';
import chemistry from './assets/images/chemistry.png';

import dansol from './assets/images/dansol-logo.png';
import mccLogo from './assets/images/mcc-logo.png';
import ressun from './assets/images/ressun.png';
import helsinkiLogo from './assets/images/helsinki.png';
import dansolHeader from './assets/images/dansol.png';
import mccHeader from './assets/images/mcc-header.png';

import Text from '../src/assets/icons/Text';
import TextImage from '../src/assets/icons/TextImage';
import Image from '../src/assets/icons/Image';
import Video from '../src/assets/icons/Video';
import Audio from '../src/assets/icons/Audio';
import Docs from '../src/assets/icons/Docs';
import Games from '../src/assets/icons/Games';
import Quiz from '../src/assets/icons/Quiz';

export const bigCardData = [
  {
    id: 1,
    icon: magnifier,
    title: 'Find a school and subject of interest',
    bodyText:
      'Select any topic from our vast database, cutting across various K-12 curricula to suite your specific academic needs',
    color: '#9FECDB',
    border: 'bl-right',
  },

  {
    id: 2,
    icon: play,
    title: 'Engage with high quality lessons and assessments',
    bodyText:
      'Enjoy engaging educational contents, images, live videos, games, quizzes, audios... from tutors around the world',
    color: '#FFAEC0',
    border: 'bl-top',
  },

  {
    id: 3,
    icon: smiley,
    title: 'Gain mastery through one- on- one classes',
    bodyText:
      'Schedule personalized learning sessions with professional tutors to tackle difficult learning subject areas',
    color: '#FFCC1D',
    border: 'bl-bottom',
  },
];

export const smallCardData = [
  {
    id: 1,
    img: agric,
    title: 'English Language',
    text: '3 Schools',
  },
  {
    id: 2,
    img: biology,
    title: 'Biology',
    text: '8 Schools',
  },
  {
    id: 3,
    img: chemistry,
    title: 'Economics',
    text: '20 Schools',
  },
  // {
  //   id: 4,
  //   img: commerce,
  //   title: "Commerce",
  //   text: "32 Schools",
  // },
  // {
  //   id: 5,
  //   img: civil,
  //   title: "Civil Education",
  //   text: "4 Schools",
  // },
  // {
  //   id: 6,
  //   img: current,
  //   title: "Current Affairs",
  //   text: "33 Schools",
  // },
];

export const schoolData = [
  {
    id: 1,
    schoolName: 'The Dansol Schools',
    description:
      'We focus on using practical life learning methods to promote an environment centr... ',
    subjectNo: '6',
    location: 'Lagos, Nigeria',
    schoolLogo: dansol,
    header: dansolHeader,
  },
  {
    id: 2,
    schoolName: 'Ressun High School',
    description:
      'We focus on using practical life learning methods to promote an environment centr... ',
    subjectNo: '3',
    location: 'Helsinki, Finland',
    schoolLogo: helsinkiLogo,
    header: ressun,
  },
  {
    id: 3,
    schoolName: 'Maple Canadian College',
    description:
      'We focus on using practical life learning methods to promote an environment centr... ',
    subjectNo: '3',
    location: 'Helsinki, Finland',
    schoolLogo: mccLogo,
    header: mccHeader,
  },
];

export const questions = [
  { id: 1, question: 'I enjoy reading books about space travel?' },
  { id: 2, question: 'I love creating business ideas?' },
  { id: 3, question: 'I love animation?' },
  { id: 4, question: 'I love writing?' },
];

export const result = [
  {
    id: 1,
    title: 'Arts and Humanities',
    description:
      'This deals with creative and critical thinking, human behavior, writing, and communications',
    percentage: '70',
  },

  {
    id: 2,
    title: 'Science',
    description:
      'This deals with the natural world in its molecular and technological aspects',
    percentage: '20',
  },
  {
    id: 3,
    title: 'Social Science',
    description:
      'This deals with human behaviour in its social and cultural aspects',
    percentage: '10',
  },
];

export const subjects = [
  { value: 'english', label: 'English' },
  { value: 'mathematics', label: 'Mathematics' },
  { value: 'biology', label: 'Biology' },
  { value: 'physics', label: 'Physics' },
  { value: 'government', label: 'Government' },
  { value: 'accounting', label: 'Accounting' },
  { value: 'civic education', label: 'Civic education' },
  { value: 'chemistry', label: 'chemistry' },
  { value: 'commerce', label: 'commerce' },
];

export const topicData = [
  {
    id: 1,
    topic: 'Pronunciation of “th”',
    description:
      'We focus on using practical life learning methods to promote an environment centr... ',
    duration: 25,
    subject: 'English Language',
    header: dansolHeader,
  },
  {
    id: 2,
    topic: 'Linear algebraic equation made easy ',
    description:
      'We focus on using practical life learning methods to promote an environment centr... ',
    duration: 15,
    subject: 'Mathematics',
    header: ressun,
  },
  {
    id: 3,
    topic: 'Geometric equations ',
    description:
      'We focus on using practical life learning methods to promote an environment centr... ',
    duration: 15,
    subject: 'Mathematics',
    header: mccHeader,
  },
];

export const whatYouWillLearn = [
  { id: 1, topic: 'Basics of Agricultural Science' },
  { id: 2, topic: 'Horticulture and farming' },
  { id: 3, topic: 'Propagation of plant systems' },
  { id: 4, topic: 'Planting of maize project' },
  { id: 5, topic: 'Adhering to farming practices for plant growth' },
  { id: 6, topic: 'Erosion and flood' },
];

export const contentTypes = [
  { id: 1, content: 'Text', icon: <Text /> },
  { id: 2, content: 'Image', icon: <Image /> },
  // { id: 3, content: 'Text & Image', icon: <TextImage /> },
  { id: 4, content: 'Video', icon: <Video /> },
  { id: 5, content: 'Audio', icon: <Audio /> },
  //{ id: 6, content: 'Quiz', icon: <Quiz /> },
  { id: 7, content: 'Docs', icon: <Docs /> },
];

export const time = [
  { id: 1, time: '12:00am' },
  { id: 2, time: '01:00am' },
  { id: 3, time: '02:00am' },
  { id: 4, time: '03:00am' },
  { id: 5, time: '04:00am' },
  { id: 6, time: '05:00am' },
  { id: 7, time: '06:00am' },
  { id: 8, time: '07:00am' },
  { id: 9, time: '08:00am' },
  { id: 10, time: '09:00am' },
  { id: 11, time: '10:00am' },
  { id: 12, time: '11:00am' },
  { id: 13, time: '12:00pm' },
  { id: 15, time: '01:00pm' },
  { id: 16, time: '02:00pm' },
  { id: 17, time: '03:00pm' },
  { id: 18, time: '04:00pm' },
  { id: 19, time: '05:00pm' },
  { id: 20, time: '06:00pm' },
  { id: 21, time: '07:00pm' },
  { id: 22, time: '08:00pm' },
  { id: 23, time: '09:00pm' },
  { id: 24, time: '10:00pm' },
  { id: 25, time: '11:00pm' },
];

export const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    paritialVisibilityGutter: 60,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    paritialVisibilityGutter: 60,
  },
};

export const durationTypes = ['Days', 'Weeks', 'Months', 'Years'];
export const currencyTypes = [
  {
    id: 1,
    title: 'Nigerian Naira (₦)',
    symbol: '₦',
  },
  {
    id: 2,
    title: 'US Dollars ($)',
    symbol: '$',
  },
];
